// extracted by mini-css-extract-plugin
export default {"BtnBack":"IconBtnBack_BtnBack__LbMjG","rotation":"IconBtnBack_rotation__OfeEb"};